<template>
    <div>
        <select
            class="form-control"
            :id="id"
            :name="name"
            :placeholder="placeholder"
            :disabled="disabled"
            :readonly="readonly"
            :required="required"
            :value="value"
            :data-cy="dataCy"
            ><slot></slot
        ></select>
        <span class="help-block text-danger" v-if="error">{{ error }}</span>
    </div>
</template>

<script>
/*
        External package https://github.com/godbasin/vue-select2/tree/npm-publish-code
        was adapted to fit the needs of this project
     */

import $ from "jquery";
import "select2/dist/js/select2.full";

export default {
    name: "Select2",
    data() {
        return {
            select2: null
        };
    },
    model: {
        event: "change",
        prop: "value"
    },
    props: {
        id: {
            type: String,
            default: ""
        },
        name: {
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            default: ""
        },
        dataCy: {
            type: String,
            default: "",
        },
        options: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        settings: {
            type: Object,
            default: () => {}
        },
        dropdownParent: {
            type: Object,
            default: null
        },
        value: null,
        error: null
    },
    watch: {
        options(val) {
            this.setOption(val);
        },
        value(val) {
            this.setValue(val);
        }
    },
    computed:{
        dropdownParentElement(){
            if(this.dropdownParent !== null){
                return Object.keys($("#modalContent")).length === 0 ? $("#modalContentCashRegister") : $("#modalContent")
            }
            return null
        },
    },
    methods: {
        setOption(val = []) {
            this.select2.empty();
            this.select2.select2({
                ...this.settings,
                dropdownParent: this.dropdownParentElement,
                data: val
            });
            this.setValue(this.value);
        },
        setValue(val) {
            if (val instanceof Array) {
                this.select2.val([...val]);
            } else {
                this.select2.val([val]);
            }
            this.select2.trigger("change");
        }
    },
    mounted() {
        const _this = this;
        let config = {
            ...this.settings,
            dropdownParent: this.dropdownParentElement,
            language: {
                noResults: function() {
                    return _this.__("no_positions"); // Twój komunikat
                }
            },
            data: this.options
        }

            // this.dropdownParent === null
            //     ? {
            //           ...this.settings,
            //           data: this.options
            //       }
            //     : {
            //           ...this.settings,
            //           dropdownParent: Object.keys($("#modalContent")).length === 0 ? $("#modalContentCashRegister") : $("#modalContent"),
            //           data: this.options
            //       };

        this.select2 = $(this.$el)
            .find("select")
            .select2(config)
            .on("select2:select select2:unselect", ev => {
                this.$emit("change", this.select2.val());
                this.$emit("input", this.select2.val());
                this.$emit("select", ev["params"]["data"]);
            });
        this.setValue(this.value);
        $(this.$el).find("select").on('select2:open select2:close', function() {
            let searchField = $(".select2-search__field")[0];
            if(isSet(searchField)) {
                searchField.focus();
            }
        })
    },
    beforeDestroy() {
        this.select2.select2("destroy");
    }
};
</script>
